import React, { ChangeEvent, CSSProperties, useEffect, useState } from 'react'
import {
  ParentDataType,
  PayloadCreateDataType,
  PayloadEditDataType,
} from '../../containers/ProfileParentsPage/types'
import InputMask from 'react-input-mask'
import isEmail from 'validator/lib/isEmail'

// Styles
import './styles.scss'

// Icons
import IconEdit from '../AvatarParentBlock/images/iconEdit'
import IconSave from './images/iconSave'
import IconCancel from './images/iconCancel'

export default ({
  style,
  colorEditIcon,
  colorInput,
  gender,
  parentData,
  onCreate,
  onSave,
}: {
  style: CSSProperties
  colorEditIcon: string
  colorInput: string
  gender: 'male' | 'female'
  parentData: ParentDataType
  onCreate: (data: PayloadCreateDataType) => void
  onSave: (data: PayloadEditDataType) => void
}) => {
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [email, setEmail] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [emailError, setEmailError] = useState<boolean>(false)
  const [phoneError, setPhoneError] = useState<boolean>(false)

  useEffect(() => {
    if (parentData) {
      setEmail(parentData.contact_email || '')
      setPhone(parentData.contact_phone || '')
    }
  }, [parentData])

  const onChangeEmail = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.currentTarget.value)
  }

  const onChangePhone = (event: ChangeEvent<HTMLInputElement>) => {
    setPhone(event.currentTarget.value)
  }

  const handleSaveFrom = () => {
    const formatPhone = phone.replace(/[^\d]/g, '')

    setEmailError(!isEmail(email))
    setPhoneError(formatPhone.length !== 11)
    if (!isEmail(email) || formatPhone.length !== 11) return
    if (parentData) {
      onSave({
        parent_id: parentData.profile_id,
        contact_email: email,
        contact_phone: `+${formatPhone}`,
      })
    } else {
      onCreate({
        gender,
        contact_email: email,
        contact_phone: `+${formatPhone}`,
      })
    }
    setIsEdit(false)
  }

  return (
    <div style={style} className={'contacts-parent-block'}>
      <div className={'header'}>
        <span className={'header__title'}>Контактные данные</span>
        <div className={'header__nav'}>
          {isEdit ? (
            <>
              <IconSave
                onClick={handleSaveFrom}
                className={'header__nav-button'}
                style={{ margin: '0 9px 0 30px' }}
              />
              <IconCancel
                className={'header__nav-button'}
                onClick={() => setIsEdit(false)}
              />
            </>
          ) : (
            <IconEdit
              className={'header__nav-button'}
              color={colorEditIcon}
              onClick={() => setIsEdit(true)}
            />
          )}
        </div>
      </div>
      <div className={'personal-edit-block__column'}>
        <div className={'personal-edit-block__column-field'}>
          <div style={{ minWidth: 70 }} className={'label'}>
            E-mail:
          </div>
          <input
            value={email}
            disabled={!isEdit}
            className={emailError ? 'error' : ''}
            style={!isEdit ? { background: colorInput } : {}}
            onChange={onChangeEmail}
          />
        </div>
        <div className={'personal-edit-block__column-field'}>
          <div className={'label'}>Телефон:</div>
          <InputMask
            value={phone}
            mask={'+7(999)999-99-99'}
            disabled={!isEdit}
            className={phoneError ? 'error' : ''}
            style={!isEdit ? { background: colorInput } : {}}
            onChange={onChangePhone}
          />
        </div>
      </div>
    </div>
  )
}
